import { ItemChartModel } from '../global/item-chart.model';

export class RemissionChartModel {
  total: number = 0;
  states: ItemChartModel[] = [];
}
